// Internal analytics — package/upsell funnel events. No third-party service:
// events land in the app's own DB (POST /api/analytics/event) for later
// attach-rate / AOV analysis. Fire-and-forget, never blocks UI.
import { api } from "@/lib/api";

export function track(event, data = {}) {
  try {
    api.post("/analytics/event", {
      event,
      data,
      page: typeof window !== "undefined" ? window.location.pathname : "",
    }).catch(() => {});
  } catch {
    /* analytics must never break the UI */
  }
}
